import type { FC } from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Card } from '@/components/ui/card/Card';
import { useTranslation } from '@/hooks/useTranslation';
import type { Process } from '../type/Process';

interface ProcessSelectedChipProps {
  process: Process;
  hiddenCount: number;
  onChange: () => void;
  onClear: () => void;
}

export const ProcessSelectedChip: FC<ProcessSelectedChipProps> = ({
  process,
  hiddenCount,
  onChange,
  onClear,
}) => {
  const { t } = useTranslation();

  return (
    <Card
      tier="muted"
      padding="none"
      className="flex flex-wrap items-center gap-2 px-4 py-2 text-sm"
    >
      <span className="font-semibold text-muted-foreground">
        {t('traceability.processSelection.chip.label')}
      </span>
      <span className="font-medium text-foreground">{process.name}</span>
      <Badge tone="primary">{t(`traceability.processSelection.type.${process.processType}`)}</Badge>
      <Badge>{t('traceability.processSelection.chip.hidden', { count: hiddenCount })}</Badge>
      <div className="ml-auto flex gap-2">
        <Button type="button" variant="ghost" size="sm" onClick={onChange}>
          {t('traceability.processSelection.chip.change')}
        </Button>
        <Button type="button" variant="ghost" size="sm" onClick={onClear}>
          {t('traceability.processSelection.chip.clear')}
        </Button>
      </div>
    </Card>
  );
};
